import { put } from "redux-saga/effects";
import axios from "../../axios-local-api";
import * as actions from "../actions";

export function* initCellularSaga() {
  try {
    const featureFlags = yield sessionStorage.getItem("featureFlags") || "";
    let testParam = "";
    if (featureFlags.includes("cellularTestFailover")) {
      testParam = "?test=failover";
    } else if (featureFlags.includes("cellularTest")) {
      testParam = "?test=true";
    }
    const { data } = yield axios.get(`/cellular${testParam}`);
    yield put(actions.setCellular(data));
  } catch (error) {
    yield put(actions.fetchCellularFailed());
  }
}
